import { Expose } from 'class-transformer';

export class MacAddress {
  id: number;
  mac: string;
  @Expose({ name: 'is_assigned' })
  isAssigned: boolean;
}
